import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaArrowRight,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-b from-[#f7f9fb] to-[#e8edf2] text-[#1A202C] overflow-hidden">
      
      {/* TOP DECOR */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gray-400 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-14">

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-14">

          {/* BRAND */}
          <div className="lg:col-span-5">
            <img
              src="/image/logo/LOGO.png"
              alt="Holly Zolly Logo"
              className="h-24 object-contain mix-blend-multiply"
            />

            <p className="mt-6 text-[15px] leading-7 text-gray-600 max-w-md">
              Discover authentic Vastu products crafted to invite positivity,
              harmony, prosperity, and peaceful energy into your home and
              workspace.
            </p>

            {/* SOCIAL */}
            <div className="flex items-center gap-4 mt-8">
              {[
                {
                  icon: <FaFacebookF />,
                  link: "https://www.facebook.com/share/1ZZRAgzFhf/",
                  color: "hover:bg-[#1877F2]",
                },
                {
                  icon: <FaInstagram />,
                  link: "https://www.instagram.com/_kkvastukkalp?igsh=N2ZzMm9iYmY2empp",
                  color: "hover:bg-gradient-to-r hover:from-pink-500 hover:to-orange-400",
                },
                {
                  icon: <FaYoutube />,
                  link: "https://youtube.com/@kkvastukkalp2985?si=3__QeYemSQT9Me8h",
                  color: "hover:bg-[#FF0000]",
                },
              ].map((item, i) => (
                <a
                  key={i}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-11 h-11 rounded-full border border-gray-300 flex items-center justify-center text-gray-600 transition-all duration-300 hover:text-white hover:scale-110 ${item.color}`}
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="lg:col-span-2">
            <h3 className="text-[15px] font-bold uppercase tracking-[3px] mb-7 text-gray-900">
              Quick Links
            </h3>

            <ul className="space-y-4">
              {["Home", "Shop", "Wishlist", "Cart", "Contact"].map((item) => (
                <li key={item}>
                  <Link
                    to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                    className="group flex items-center gap-2 text-[15px] text-gray-600 hover:text-black transition-all duration-300"
                  >
                    <FaArrowRight className="text-[11px] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CUSTOMER SERVICE */}
          <div className="lg:col-span-2">
            <h3 className="text-[15px] font-bold uppercase tracking-[3px] mb-7 text-gray-900">
              Support
            </h3>

            <ul className="space-y-4">
              {[
                { name: "FAQ", path: "/faq" },
                { name: "Returns Policy", path: "/returns" },
                { name: "Privacy Policy", path: "/privacy-policy" },
                { name: "Cancellation", path: "/cancellation" },
                { name: "Terms & Conditions", path: "/terms" },
                { name: "Payment", path: "/payment" },
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="group flex items-center gap-2 text-[15px] text-gray-600 hover:text-black transition-all duration-300"
                  >
                    <FaArrowRight className="text-[11px] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                    {item.name} 
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT */}
          <div className="lg:col-span-3">
            <h3 className="text-[15px] font-bold uppercase tracking-[3px] mb-7 text-gray-900">
              Contact
            </h3>

            <div className="space-y-5">

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-gray-700">
                  <FaEnvelope />
                </div>

                <div>
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <a
                    href="mailto:vastukkalp2007@gmail.com"
                    className="text-[15px] text-gray-700 hover:text-black transition"
                  >
                    support@holollyzolly.shop
                  </a>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-gray-700">
                  <FaPhoneAlt />
                </div>

                <div>
                  <p className="text-sm text-gray-400 mb-1">Phone</p>
                  <a
                    href="tel:+919909511961"
                    className="text-[15px] text-gray-700 hover:text-black transition"
                  >
                    +91 99095 11961
                  </a>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-gray-700">
                  <FaMapMarkerAlt />
                </div>

                <div>
                  <p className="text-sm text-gray-400 mb-1">Location</p>
                  <p className="text-[15px] leading-7 text-gray-700">
                    D-211 Adishwar Nagar, <br />
                    Nikol Road, Naroda, Ahmedabad.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>        

      </div>

      {/* COPYRIGHT */}
      <div className="border-t border-gray-300/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-[14px] text-gray-500">

          <p>
            © {new Date().getFullYear()} HOLLY ZOLLY — All Rights Reserved.
          </p>

          <div className="flex items-center gap-3">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
            <span>Designed with Harmony & Positive Energy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}